/**
 * Name titles and their corresponding values.
 *
 * Current list is obtained from all the unique titles in the users table which was obtained from the CIP.
 */
export const titles = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mister', value: 'Mister' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Dr', value: 'Dr' },
  { label: 'Doctor', value: 'Doctor' },

  { label: 'Professor', value: 'Professor' },
  { label: 'Professor', value: 'Prof' },
  { label: 'Associate Professor', value: 'Associate Professor' },
  { label: 'Assistant Professor', value: 'Assistant Professor' },
  { label: 'Emeritus Professor', value: 'Emeritus Professor' },
  { label: 'Emerita Professor', value: 'Emerita Professor' },
  { label: 'Honorary Professor', value: 'Honorary Professor' },
  { label: 'Adjunct Professor', value: 'Adjunct Professor' },

  { label: 'Mx', value: 'Mx' },
  { label: 'AsPr', value: 'AsPr' },
  { label: 'Pastor', value: 'Pastor' },
  { label: 'Sister', value: 'Sister' },
  { label: 'Lady', value: 'Lady' },
  { label: 'Sir', value: 'Sir' },
  { label: 'Br', value: 'Br' },
  { label: 'Rev', value: 'Rev' },
  { label: 'Fr', value: 'Fr' },
  { label: 'Sr', value: 'Sr' },
  { label: 'Pstr', value: 'Pstr' },
  { label: 'The Hon Justice', value: 'The Hon Justice' },
  { label: 'Reverend', value: 'Reverend' },
  { label: 'The Honourable', value: 'The Honourable' },
  { label: 'Venerable', value: 'Venerable' },
  { label: 'Rev Dr', value: 'Reverend Dr' },
  { label: 'EmPr', value: 'EmPr' },
]

/**
 * Filter user titles obtained from the CIP.
 *
 * Exclude duplicate titles (Mister, Doctor, Prof)
 */
const excludedValues = new Set(['Mister', 'Doctor', 'Prof'])

export const filteredUserTitles = titles.filter((title) => !excludedValues.has(title.value))
